function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: 12px;\n  width: 100%;\n  height: 14px;\n  border: 1px solid #abb6bc;\n  border-radius: 8px;\n  background-color: #f4f6f7 !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 14px;\n  appearance: none;\n  background: transparent;\n  outline: none !important;\n  outline-width: 0 !important;\n\n  &:focus,\n  &:active {\n    outline: none !important;\n  }\n  &::-webkit-slider-runnable-track {\n    width: 96%;\n    height: 14px;\n    cursor: pointer;\n  }\n  &::-webkit-slider-thumb {\n    outline: none;\n    border: 1px solid #919891;\n    height: 20px;\n    width: 20px;\n    border-radius: 15px;\n    background: ",
        ";\n    cursor: pointer;\n    appearance: none;\n    transform: translate(-2px, -27%);\n  }\n  &::-moz-range-thumb {\n    outline: none;\n    border: 1px solid #919891;\n    height: 20px;\n    width: 20px;\n    border-radius: 15px;\n    background: ",
        ";\n    cursor: pointer;\n    appearance: none;\n    transform: translate(-2px, -15%);\n  }\n  &::-moz-range-progress {\n    background-color: transparent;\n  }\n  &::-moz-range-track {\n    background-color: transparent;\n    height: 14px;\n    cursor: pointer;\n    width: 96%;\n  }\n  &::-ms-fill-lower {\n    background-color: transparent;\n  }\n  &::-ms-fill-upper {\n    background-color: transparent;\n  }\n  &::-moz-focus-outer {\n    border: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { colors } from 'shared/styles.js';
var SliderContainer = styled(Box)(_templateObject());
var Slider = styled.input(_templateObject1(), colors.grey2, colors.grey2);
var background = function(param) {
    var _param_value = param.value, value = _param_value === void 0 ? 0.0 : _param_value, _param_backgroundColor = param.backgroundColor, backgroundColor = _param_backgroundColor === void 0 ? '#8ecbb5' : _param_backgroundColor, min = param.min, max = param.max;
    var range = max - min;
    var percent1 = 100 / range * (value - min);
    var percent2 = 100 - percent1; // (100 / range) * (max - value);
    if (value >= (range - min) / 2) {
        return "linear-gradient(90deg, ".concat(backgroundColor, " ").concat(percent1 - 2, "%, #f4f6f7 ").concat(percent2, "%)");
    }
    return "linear-gradient(270deg, #f4f6f7 ".concat(percent2, "%, ").concat(backgroundColor, " ").concat(percent1 + 15, "%)");
};
export default function(param) {
    var name = param.name, defaultValue = param.defaultValue, onChange = param.onChange, value = param.value, backgroundColor = param.backgroundColor, min = param.min, max = param.max, _param_label = param.label, label = _param_label === void 0 ? '' : _param_label;
    return /*#__PURE__*/ _jsx(SliderContainer, {
        style: {
            background: background({
                value: Number(value),
                backgroundColor: backgroundColor,
                min: min,
                max: max
            })
        },
        children: /*#__PURE__*/ _jsx(Slider, {
            "aria-label": label,
            name: name,
            type: "range",
            min: min,
            max: max,
            defaultValue: defaultValue,
            onChange: onChange
        })
    });
};
